<script setup lang="ts">
import { getSeoObject } from "~/helpers/seo";
import { TagCard } from "#components";

const { data } = useCustomFetch("/api/strapi/tags-page");
const { data: tagsData } = useCustomFetch("/api/strapi/tags");

// useSeoMeta(getSeoObject(data?.value?.seo));
</script>

<template>
  <section v-if="data" class="main-container">
    <SeoMeta v-if="data?.seo" v-bind="data?.seo" />
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <h2 class="page-title">{{ data.title }}</h2>
          <p class="text-center" style="white-space: pre-line">
            {{ data.description }}
          </p>
        </div>
      </div>
      <div class="hstack" v-if="tagsData">
        <div v-for="tag in tagsData" class="gap-3">
          <NuxtLink :to="`/education-tags/${tag?.attributes?.slug}`">
            <TagCard :title="tag.attributes.name" />
          </NuxtLink>
        </div>
      </div>
    </div>
  </section>
</template>
